/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_2Inputs */

const en_gc_search_guides_gridcraft_online_sections_4_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish the session by saving a clearly named test file and reopening it. Keep your test deliberately small: one input, one calculated result and one saved copy. This establishes the whole online workflow before you spend time formatting a large table or importing a workbook whose dependencies you have not inspected. You should be able to point to the file that now contains your change.`)
};

const zh_gc_search_guides_gridcraft_online_sections_4_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后保存一个命名清楚的测试文件，并重新打开。测试应保持简单：一个输入、一个计算结果和一个保存副本。在花时间排版大表格或导入依赖不明的文件前，先验证整个在线流程。你应能明确指出修改已保存在哪个文件里。`)
};

/**
* | output |
* | --- |
* | "Finish the session by saving a clearly named test file and reopening it. Keep your test deliberately small: one input, one calculated result and one saved co..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_4_paragraphs_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_4_paragraphs_2(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_4_paragraphs_2(inputs)
});
export { gc_search_guides_gridcraft_online_sections_4_paragraphs_2 as "gc.search_guides.gridcraft_online.sections.4.paragraphs.2" }